export type Mode = 'date' | 'time' | 'datetime' | 'range';

export const MIN_YEAR = 1900;
export const MAX_YEAR = 2100;

export const pad = (num: number) => num.toString().padStart(2, '0');

export const formatDateValue = (date: Date | null) => {
  if (!date) return '';
  const y = date.getFullYear();
  const m = pad(date.getMonth() + 1);
  const d = pad(date.getDate());
  return `${y}-${m}-${d}`;
};

export const formatTimeValue = (date: Date | null) => {
  if (!date) return '';
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatDateTimeValue = (date: Date | null) => {
  if (!date) return '';
  return `${formatDateValue(date)}T${formatTimeValue(date)}`;
};

export const parseValue = (value: string | undefined, mode: Mode): Date | null => {
  if (!value) return null;
  if (mode === 'date') {
    const [year, month, day] = value.split('-').map(Number);
    if (!year || !month || !day) return null;
    if (year < MIN_YEAR || year > MAX_YEAR) return null;
    return new Date(year, month - 1, day);
  }

  if (mode === 'time') {
    const [hours, minutes] = value.split(':').map(Number);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    const now = new Date();
    now.setHours(hours, minutes, 0, 0);
    return now;
  }

  const [datePart, timePart] = value.split('T');
  if (!datePart || !timePart) return null;
  const [year, month, day] = datePart.split('-').map(Number);
  const [hours, minutes] = timePart.split(':').map(Number);
  if (!year || !month || !day || Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  if (year < MIN_YEAR || year > MAX_YEAR) return null;
  return new Date(year, month - 1, day, hours, minutes, 0, 0);
};

export const buildWeekDays = () => ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export const monthNames = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];
